import React from 'react'
import { FormGroup, Label, Input } from 'reactstrap'

const RhDateRangeCalendar = ({ min, max, startDate, endDate, onChange }) => {
  const handleStart = (e) => {
    const start = e.target.value
    let end = endDate || ''
    if (end && start > end) end = start
    onChange({ start, end })
  }

  const handleEnd = (e) => {
    const end = e.target.value
    let start = startDate || ''
    if (start && end < start) start = end
    onChange({ start, end })
  }

  return (
    <>
      <FormGroup className="mb-2">
        <Label className="small mb-1">Data de início</Label>
        <Input
          type="date"
          value={startDate || ''}
          min={min}
          max={max}
          onChange={handleStart}
        />
      </FormGroup>
      <FormGroup className="mb-0">
        <Label className="small mb-1">Data de fim</Label>
        <Input
          type="date"
          value={endDate || ''}
          min={min}
          max={max}
          onChange={handleEnd}
        />
      </FormGroup>
    </>
  )
}

export default RhDateRangeCalendar
